import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowIcon, CalendarIcon, MsTeamsLogo, WatchIcon } from 'shared/icons';
import { MeetingType } from 'types/Meeting/MeetingType';

export const UpcomingMeeting: FC<MeetingType> = ({ url, displayTime, displayDate, title }) => {
  const { t } = useTranslation();
  return (
    <aside className="bg-primary-100 flex flex-wrap items-center gap-4 rounded-xl p-4 text-sm">
      <MsTeamsLogo className="h-6 w-6 shrink-0" />
      <div className="min-w-0 flex-1">
        <p className="text-xs text-black/60">{t('common:navbar.upcomingMeeting')}</p>
        <p className="font-medium">{title}</p>
      </div>
      <div className="flex flex-wrap items-center gap-4 text-xs text-black/70">
        <span className="flex items-center gap-2">
          <CalendarIcon className="h-4 w-4" />
          {displayDate}
        </span>
        <span className="flex items-center gap-2">
          <WatchIcon className="h-4 w-4" />
          {displayTime}
        </span>
      </div>
      {url && (
        <a
          href={url}
          target="_blank"
          rel="noreferrer"
          className="bg-primary hover:bg-primary/80 inline-flex items-center gap-2 rounded px-4 py-2.5 font-medium text-white"
        >
          {t('action:join')}
          <ArrowIcon className="h-4 w-4 rotate-180" />
        </a>
      )}
    </aside>
  );
};
